module.exports = __webpack_public_path__ + "static/img/pass_物联网.e7acad14.png";